import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

import { CACHE_KEY } from '../constants';

const SpotlightContext = createContext();

const SpotlightProvider = ({ children }) => {
    const [flow, setFlow] = useState({}); // this will hydrate with steps when a new FeatureSpotlight is created | EX: { 'dummy_feature', : [0, 1, 2] }
    const [feat, setFeature] = useState(null);
    const [s, setStep] = useState(null);

    const hydrateSteps = (fId, step) => setFlow((flow) => { // using a function ensures we have access to the latest state
        const fs = flow?.[fId];
        // feature step exists but not the current step
        return fs && !fs?.includes(step)
            ? { ...flow, [fId]: [...fs, step].sort((a, b) => a - b) } // add current step while sorting
            : { ...flow, [fId]: [step] }; // create new feature step
    });

    const nextStep = (fId, step) => {
        const nextStep = flow?.[fId]?.[step + 1];
        setStep(nextStep ? nextStep : null); // set next step if next feature exists
        if (!nextStep) {
            setFeature(null);
            // setStep(null); 👈 already set above
            const completed = JSON.parse(localStorage.getItem(CACHE_KEY.SPOTLIGHT_COMPLETED)) || [];
            localStorage.setItem(CACHE_KEY.SPOTLIGHT_COMPLETED, JSON.stringify([...completed, feat]));
        }
    };

    // eslint-disable-next-line react/no-children-prop
    return <SpotlightContext.Provider value={{ feat, setFeature, s, setStep, hydrateSteps, nextStep }} children={children} />;

};

SpotlightProvider.propTypes = {
    children: PropTypes.shape()
};


export { SpotlightProvider, SpotlightContext };